import React from 'react';

export interface KeeperError {
  message: string;
  code?: string;
  retryAfterSeconds?: number;
}

interface KeeperErrorBandProps {
  error: KeeperError;
  lastKeeperDate?: string;
  hasPriorAssessment: boolean;
}

// [KEEP2] Makes a failed fresh analysis visible instead of silently falling back
// to the prior assessment. Shared by the desktop row and the mobile card. The
// prior assessment may still render beneath it, but never without this band.
export function KeeperErrorBand({ error, lastKeeperDate, hasPriorAssessment }: KeeperErrorBandProps) {
  return (
    <div className="bg-danger-50 border border-danger-100 rounded-md p-3">
      <p className="text-xs text-danger-700 font-medium leading-snug">
        Fresh analysis failed: {error.message}
        {hasPriorAssessment && lastKeeperDate && (
          <> Showing assessment from {new Date(lastKeeperDate).toLocaleDateString()}.</>
        )}
      </p>
    </div>
  );
}

// Maps a rejected runKeeperFlow error to a single user-facing line.
export function describeKeeperError(err: any): KeeperError {
  const code: string | undefined = err?.code;
  const retryAfterSeconds: number | undefined = err?.retryAfterSeconds;
  if (code === 'GEMINI_RATE_LIMIT') {
    const minutes = Math.max(1, Math.ceil((retryAfterSeconds ?? 0) / 60));
    return {
      message: `Analysis limit reached — try again in ~${minutes} minute${minutes === 1 ? '' : 's'}.`,
      code,
      retryAfterSeconds,
    };
  }
  return {
    message: err?.message ? String(err.message) : 'Please try again.',
    code,
    retryAfterSeconds,
  };
}
